<template>
  <div>
    <h1>Ventas de productos</h1>
    <v-form ref="formVenta" v-model="formValido" lazy-validation>
      <v-row>
        <v-col cols="12" md="4">
          <v-select
            v-model="venta.idProducto"
            :items="productos"
            item-text="nombre"
            item-value="id"
            label="Producto"
            :rules="[v => !!v || 'Selecciona un producto']"
            required
          />
        </v-col>
        <v-col cols="12" md="4">
          <!-- AUTOCOMPLETE CON BACKEND PARA MIEMBROS -->
          <v-autocomplete
            v-model="venta.idMiembro"
            :items="miembros"
            :loading="buscandoMiembros"
            item-text="nombre"
            item-value="id"
            label="Miembro"
            :rules="[v => !!v || 'Selecciona un miembro']"
            required
            return-object
            :item-text="item => item.nombre + ' (' + item.matricula + ')'"
            hide-no-data
            hide-selected
            clearable
            @update:search-input="onBuscarMiembro"
          >
            <template v-slot:item="{ item }">
              {{ item.nombre }} ({{ item.matricula }})
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="venta.nombreVisita"
            label="Nombre de la visita (opcional)"
            placeholder="Sin nombre"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model.number="venta.cantidad"
            label="Cantidad"
            type="number"
            min="1"
            :rules="[v => v > 0 || 'Cantidad mayor a 0']"
            required
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="venta.precio_unitario"
            label="Precio unitario"
            type="number"
            :readonly="true"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="venta.total"
            label="Total"
            type="number"
            :readonly="true"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            v-model="venta.metodo_pago"
            :items="metodosPago"
            label="Método de pago"
            :rules="[v => !!v || 'Selecciona un método de pago']"
            required
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" @click="registrarVenta" :disabled="!formValido">Registrar venta</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-data-table
      :headers="encabezadoTabla"
      :items="ventas"
      class="elevation-1 mt-5"
      :footer-props="{itemsPerPageText: 'Por página'}"
    >
      <template v-slot:item.fecha="{ item }">
        {{ new Date(item.fecha).toLocaleString() }}
      </template>
    </v-data-table>
    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top>
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>
<script>
import HttpService from '../../Servicios/HttpService'
export default {
  name: 'Ventas',
  data: () => ({
    formValido: false,
    productos: [],
    miembros: [],
    ventas: [],
    metodosPago: [
      { text: 'Efectivo', value: 'efectivo' },
      { text: 'Transferencia', value: 'transferencia' }
    ],
    venta: {
      idProducto: '',
      idMiembro: '',
      nombreVisita: '',
      cantidad: 1,
      precio_unitario: 0,
      total: 0,
      fecha: '',
      metodo_pago: ''
    },
    encabezadoTabla: [
      { text: 'ID', value: 'id' },
      { text: 'Producto', value: 'nombre_producto' },
      { text: 'Miembro', value: 'nombre_miembro' },
      { text: 'Cantidad', value: 'cantidad' },
      { text: 'Precio unitario', value: 'precio_unitario' },
      { text: 'Total', value: 'total' },
      { text: 'Método de pago', value: 'metodo_pago' },
      { text: 'Fecha', value: 'fecha' }
    ],
    mostrarMensaje: false,
    mensaje: { texto: '', color: '' },
    buscandoMiembros: false,
  }),
  mounted() {
    this.cargarProductos();
    // No cargar todos los miembros al inicio para optimizar
    this.cargarVentas();
  },
  watch: {
    'venta.idProducto'(nuevo) {
      const prod = this.productos.find(p => p.id === nuevo);
      if (prod) {
        this.venta.precio_unitario = prod.precio;
        this.venta.total = this.venta.cantidad * prod.precio;
        if (prod.stock === 0) {
          this.formValido = false;
          this.mostrarMensaje = true;
          this.mensaje = { texto: 'No hay stock disponible para este producto.', color: 'error' };
        }
      }
    },
    'venta.cantidad'(nuevo) {
      this.venta.total = nuevo * this.venta.precio_unitario;
    }
  },
  methods: {
    cargarProductos() {
      HttpService.obtenerConDatos({metodo: 'obtener'}, 'productos.php').then(res => {
        this.productos = res;
      });
    },
    // El método cargarMiembros ya no se usa al inicio
    buscarMiembros(termino) {
      this.buscandoMiembros = true;
      HttpService.obtenerConDatos({metodo: 'buscar', termino}, 'miembros.php').then(res => {
        let miembros = (res.miembros || []);
        // Si hay un miembro seleccionado y no está en la lista, lo agregamos al inicio
        if (
          this.venta.idMiembro &&
          this.venta.idMiembro.id &&
          !miembros.some(m => m.id === this.venta.idMiembro.id)
        ) {
          miembros.unshift(this.venta.idMiembro);
        }
        miembros.push({ id: 'visita', nombre: 'Visita (compra ocasional)', matricula: '' });
        this.miembros = miembros;
        this.buscandoMiembros = false;
      }).catch(() => {
        this.miembros = [];
        this.buscandoMiembros = false;
      });
    },
    cargarVentas() {
      HttpService.obtenerConDatos({metodo: 'obtener'}, 'ventas_productos.php').then(res => {
        this.ventas = res;
      });
    },
    registrarVenta() {
      if (!this.formValido) return;
      const idUsuario = localStorage.getItem('idUsuario');
      let venta = {
        ...this.venta,
        idUsuario: idUsuario,
        fecha: new Date().toISOString().slice(0, 19).replace('T', ' ')
      };
      if (venta.idMiembro && venta.idMiembro.id === 'visita') {
        venta.idMiembro = null;
        venta.nombreVisita = venta.nombreVisita && venta.nombreVisita.trim() ? venta.nombreVisita : 'Sin nombre';
      } else if (typeof venta.idMiembro === 'object') {
        venta.idMiembro = venta.idMiembro.id;
        venta.nombreVisita = null;
      }
      // Validar método de pago
      if (!venta.metodo_pago) {
        this.mostrarMensaje = true;
        this.mensaje = { texto: 'Selecciona un método de pago', color: 'error' };
        return;
      }
      HttpService.registrar({metodo: 'registrar', venta}, 'ventas_productos.php').then(res => {
        if (res && res.success) {
          this.mostrarMensaje = true;
          this.mensaje = { texto: res.mensaje, color: 'success' };
          this.cargarVentas();
          this.cargarProductos();
        } else if (res && res.mensaje) {
          this.mostrarMensaje = true;
          this.mensaje = { texto: res.mensaje, color: 'error' };
        } else {
          this.mostrarMensaje = true;
          this.mensaje = { texto: 'Error al registrar la venta', color: 'error' };
        }
      });
    },
    onBuscarMiembro(termino) {
      if (typeof termino !== 'string' || termino.length < 4) return;
      this.buscarMiembros(termino);
    }
  }
}
</script> 


// WEBPACK FOOTER //
// src/components/Ventas/Ventas.vue